module.exports = __webpack_public_path__ + "img/job.959a77da.svg";